import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { routeFilteringSchema } from '../routeSchema';
import { RouteListing } from '../Pages/listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import factoryService from '../../Factory/services';
import collectionCategoryService from '../../CollectionCategory/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'ROUTE';

export function RouteFilter(props) {

    const [title, setTitle] = useState("Routes");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [collectionCategory, setCollectionCategory] = useState();
    const [routeData, setRouteData] = useState([]);
    const [route, setRoute] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionCatagoryID: '0',
    });

    const schema = Joi.object(routeFilteringSchema).options({ allowUnknown: true });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntityForDropdown()
        )
    }, [route.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
        )
        handleSearch();
    }, [route.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWROUTELISTING');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITROUTE');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setRoute({
            ...route,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropdown()
        )
    }

   

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntityForDropdown() {
        const operationEntity = await services.getFactoryByGroupID(route.groupID);
        setOperationEntity(operationEntity);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategory = await collectionCategoryService.GetCollectionCategoryByOperationEntityID(route.operationEntityID);
        setCollectionCategory(collectionCategory);
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, routeFilteringSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];


        setRoute({
            ...route,
            [e.target.name]: value
        });
        setErrors(error);
    }

    async function handleSearch(e) {

        if(e !== undefined){
            const errorMessages = validate(schema, route);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }
        
        const response = await services.getRouteFilterData(route);
        setRouteData(response);
    }

    async function editRoute(data) {
        props.history.push({
            pathname: 'routes/addEdit',
            data: data,
            edit: true
        });
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setRoute({
            ...route,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionCatagoryID: '0',
        });
        setRouteData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    path="routes/addEdit"
                                    buttonText="Add Routes"
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={route.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <div className="col-md pb-1">
                                            <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                            <Select
                                                fullWidth
                                                labelId="operationEntityID"
                                                id="operationEntityID"
                                                name="operationEntityID"
                                                disabled={!permissionList.isOperationEntityFilterEnabled}
                                                value={route.operationEntityID}
                                                onChange={(e) => handleChange(e)}>
                                                <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                                {generateDropDownMenu(operationEntity)}
                                            </Select>
                                            {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                        </div>
                                        {errors["operation Entity"] && <FormHelperText error>{errors["operation Entity"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionCatagoryID"> Collection Category</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionCatagoryID"
                                            id="collectionCatagoryID"
                                            name="collectionCatagoryID"
                                            value={route.collectionCatagoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Collection Category--</MenuItem>
                                            {generateDropDownMenu(collectionCategory)}
                                        </Select>
                                        {errors["collectionCatagoryID"] && <FormHelperText error>{errors["collectionCatagoryID"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, route)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={(e) => handleSearch(e)}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                                <RouteListing 
                                    routeData={routeData} 
                                    routes={route}
                                    groups={groups}
                                    operationEntity={operationEntity}
                                    collectionCategory={collectionCategory}
                                    handleClick={editRoute} 
                                    editEnabled={permissionList.isAddEditEnabled}
                                />

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}